module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/fancy-box/fancy-box-button/fancy-box-button.component.scss
// module id = ./src/app/features/fancy-box/fancy-box-button/fancy-box-button.component.scss
// module chunks = main